const { REACT_APP_ENV = 'dev' } = process.env;
const config = require(`./${REACT_APP_ENV}.config.js`);

module.exports = {
  ...config,
};



// WEBPACK FOOTER //
// ./src/config/index.js